import { createStyles } from "antd-style";

// export const useStyles = createStyles(({ css, token, prefixCls, cx }) => {
export const useStyles = createStyles(({ css }) => {
  return {
    font: css`
      font-family: 'OspIcons';
      font-style: normal;
      font-weight: normal;
      font-variant: normal;
      text-transform: none;
      line-height: 1;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      display: inline-block;
    `,
  };
});